<template>
  <div class="content-bar">
    <div class="banner">
      <NeuralNetAll></NeuralNetAll>
    </div>
    <div class="components-out">
      <div class="x-square" v-for="(item,index) in square" :key="index">
        <img :src="item.img" alt="">
        <span>item.name</span>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import NeuralNetAll from "@/components/homepage/NeuralNetAll.vue";

export default {
  name: "HomePage",
  components: {NeuralNetAll},
  data(){
    return {
      square: []
    }
  }
}
</script>

<style scoped>
.content-bar{
}
.content-bar::-webkit-scrollbar {
  display: none;
}

.text-title span{
  background-image: linear-gradient(to right, red, yellow, blue);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.components-out{
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  box-sizing: border-box;
  user-select: none;
}
.x-square{
  width: 24%;
  height: 0;
  position: relative;
  padding-bottom: 15%;
  box-sizing: border-box;
  border-radius: 10px;
  margin-top: 1%;
  box-shadow: 0 0 5px 2px rgb(0,0,0,.2);
  cursor: pointer;
  transition: all .3s;
}
.x-square:hover{
  box-shadow: 0 0 5px 2px rgb(100,100,100,.3);
}
.x-square >*{
  width: 100%;
  height: 100%;
}
.x-square div{
  position: absolute;
}
.x-square:hover div{
  height: 100%;
}
</style>